// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__2nhh6","modalForm":"UpgradeEpcsModal_modalForm__1vt2_","modalFooter":"UpgradeEpcsModal_modalFooter__hoU0r"};